import { render, staticRenderFns } from "./card-popular-review.vue?vue&type=template&id=d14cb5ba&scoped=true"
import script from "./card-popular-review.vue?vue&type=script&lang=js"
export * from "./card-popular-review.vue?vue&type=script&lang=js"
import style0 from "./card-popular-review.vue?vue&type=style&index=0&id=d14cb5ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d14cb5ba",
  null
  
)

export default component.exports